<template>
    <div class="warning-modal">
        <div class="warning-header">
            Внимание!
        </div>
        <div class="warning-content">
            <div class="warning-icon-wrapper">
                <question-circle-outlined class="warning-icon" />
            </div>
            <p v-if="this.msg" class="warning-message warning-message--flex_col">
                <span>
                    Режим чтения.
                </span>
                <span>
                    Протокол правит:
                    {{ this.msg }}
                </span>
            </p>
            <p v-else class="warning-message">
                Режим чтения.
                Протокол правит врач.
            </p>
        </div>
        <div class="warning-buttons">
            <a-button
                class="warning-btn warning-btn-no"
                @click="onReadMode"
            >
                Войти в режиме чтения
            </a-button>
            <a-button
                class="warning-btn warning-btn-yes"
                @click="onExitProtocol"
            >
                Выйти из протокола
            </a-button>
        </div>
    </div>
</template>

<script>
import QuestionCircleOutlined from '@ant-design/icons-vue/QuestionCircleOutlined';

export default {
    name: 'ReceptionWarning',
    components: {
        QuestionCircleOutlined,
    },
    props: {
        msg: {
            type: String,
            default: '',
        },
    },
    emits: ['read-mode', 'exit-protocol'],
    methods: {
        onExitProtocol() {
            this.$emit('exit-protocol');
        },
        onReadMode() {
            this.$emit('read-mode');
        },
    },
};
</script>

<style scoped lang="scss">
.warning-modal {
    width: 480px;
    background-color: #8dc07c;
    border-radius: 4px;
    overflow: hidden;
}

.warning-header {
    background-color: #8dc07c;
    color: #fff;
    text-align: left;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 500;
}

.warning-content {
    background-color: #fff;
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.warning-icon-wrapper {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    background-color: #000;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    margin-left: 14px;
}

.warning-icon {
    font-size: 28px;
    color: #fff;
    display: block;
}

.warning-message {
    margin: 0;
    font-size: 18px;
    color: #000;
    text-align: left;
    line-height: 1.5;
    max-width: 500px;
    word-wrap: break-word;

    &--flex_col {
        display: flex;
        flex-wrap: wrap;
    }
}

.warning-buttons {
    background-color: #f5f5f5;
    padding: 12px;
    display: flex;
    flex-direction: row;
    gap: 12px;
    justify-content: end;
}

.warning-btn {
    min-width: 90px;
    height: 36px;
    border-radius: 4px;
    font-size: 14px;
    border: none;
    color: #fff;
    cursor: pointer;
    transition: background-color 0.2s;
    background-color: #8dc07c;

    &:hover {
        background-color: #74b85d;
    }

    &:focus {
        outline: none;
    }

    &.warning-btn-yes {
        background-color: #fff;
        color: #8dc07c;
        border: 2px solid #8dc07c;

        &:hover {
            background-color: #f5f5f5;
            color: #74b85d;
            border: 2px solid #74b85d;
        }
    }
}
</style>
